import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from '../reducers/auth.reducer';

export const authState: any = createFeatureSelector<AuthState>('auth');

export const userData = createSelector(authState, (state: any) => {
  return state.userData;
});

export const loginError = createSelector(authState, (state: any) => {
  return state.loginError;
});
